import { render } from "./TabOverflow.vue?vue&type=template&id=dec1ff6e"
import script from "./TabOverflow.vue?vue&type=script&lang=js"
export * from "./TabOverflow.vue?vue&type=script&lang=js"
script.render = render

export default script